<template>
  <v-div class="BrowseGroups">
    <ContainerGrid>
      <LayoutItems
        v-if="showDetails"
        :items="groups"
        :component-name="componentName"
        cols="12"
        sm="6"
        md="4"
        lg="4"
      />
    </ContainerGrid>
  </v-div>
</template>

<script>
import ContainerGrid from "~/components/layout/ContainerGrid";
import LayoutItems from "~/components/layout/LayoutItems";
import mapFlags from "~/plugins/utilities/mapFlags";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

export default {
  name: "BrowseGroups",
  components: {
    ContainerGrid,
    LayoutItems,
  },
  props: {
    groups: { type: Array, required: true },
  },
  data() {
    return {
      showDetails: true,
    };
  },
  computed: {
    ...mapFlags(["browseDashboardHideDescription"]),
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
    partner() {
      return this.$config.partner;
    },
    componentName() {
      const firstItem = this.groups.length > 0 ? this.groups[0] : {};

      const type = firstItem.__typename;

      if (type === "Subject") {
        return this.areAllDescriptionsEmpty() ||
          this.browseDashboardHideDescription
          ? "SubjectSummary"
          : "SubjectOverview";
      }

      return this.areAllDescriptionsEmpty() ||
        this.browseDashboardHideDescription
        ? "CategorySummary"
        : "CategoryOverview";
    },
  },
  methods: {
    onToggleDisplay() {
      this.showDetails = !this.showDetails;
    },
    areAllDescriptionsEmpty() {
      return this.groups.every((item) => !item.description);
    },
  },
};
</script>
